var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],staticClass:"logout-view",attrs:{"element-loading-text":_vm.loadingText,"element-loading-background":"rgba(0, 0, 0, 0.1)"}})}
var staticRenderFns = []

export { render, staticRenderFns }